export function getLotameTagScript(lotameId: number) {
    const lotame = lotameId.toString()

    return `//tags.crwdcntrl.net/c/${lotame}/cc.js?ns=_cc${lotame}`
}

/**
 * We pass Lotame's Profile ID into DFP on Ad Server Interactions using the CustomTargeting
 * field. DFP passes the values through into the impression and click logs which allows Lotame to
 * link the adserver activity to a Lotame profile.
 */
export const lotameScripts = `<script type="text/javascript">
    var lotamePid;

    function extractPid(lotameData) {
        try {
            // Be sure to use the "pid" and not the "tpid". "tpid" is deprecated.
            lotamePid=lotameData.Profile.pid;
        } catch (err) {
            console.error(err)
        }
    }
</script>
<script type="text/javascript" src="//ad.crwdcntrl.net/5/c=7927/pe=y/callback=extractPid"></script>`

const enum LotameBehavior {
    Action = 'act',
    Interest = 'int',
    Media = 'med',
    GenericGeo = 'geo',
    GenericDemo = 'dem',
    GenericProperty = 'genp',
    Sitemaps = 'sm',
    CustomSegment = 'seg',
    WanAccountName = 'tp',
    GigyaUserId = 'tpid',
}

interface Lotame {
    add(type: LotameBehavior, value: any): void
    bcp(): void
}

declare const lotamePid: string | undefined

/* relies on lotameScripts being added to the head */
export const lpid = typeof lotamePid !== 'undefined' ? lotamePid : undefined

export function raiseLotameEvent(lotameId: number, action?: string, gigiyaId?: string) {
    const lotameName = '_cc' + lotameId.toString()

    if (typeof (global as any)[lotameName] === 'undefined') {
        return
    }

    const lotameObj: Lotame = (global as any)[lotameName] // lotame object returned from lotame's cc.js

    try {
        lotameObj.add(LotameBehavior.WanAccountName, 'SWMG')

        if (gigiyaId) {
            lotameObj.add(LotameBehavior.GigyaUserId, gigiyaId)
        }

        if (action) {
            lotameObj.add(LotameBehavior.Action, action)
        }

        lotameObj.bcp()
    } catch (err) {
        console.error('Lotame call failed', err)
    }
}
